import { alpha } from '@mui/material/styles';

/**
 * Indigo / Inter asks for restrained elevation: one soft, wide, low-opacity
 * drop (`0 8px 24px rgba(39, 48, 71, .06)` in light mode) rather than the
 * heavy `40px` blur the previous scale used at every level above 3.
 *
 * Index 1-3 step up gently for menus and popovers; everything above settles on
 * the card shadow so an over-elevated MUI component cannot reintroduce a
 * dramatic drop.
 */
const shadows = (themeMode = 'light') => {
  const rgb = themeMode === 'light' ? '#273047' : '#000000';
  const scale = themeMode === 'light' ? 1 : 3;

  const card = `0 8px 24px ${alpha(rgb, 0.06 * scale)}`;

  return [
    'none',
    `0 1px 2px ${alpha(rgb, 0.05 * scale)}`,
    `0 2px 6px ${alpha(rgb, 0.05 * scale)}`,
    `0 4px 12px ${alpha(rgb, 0.06 * scale)}`,
    ...Array(21).fill(card),
  ];
};

export default shadows;
